export default {
  LABELS_QUERIED(state, queriedLabels) {
    state.queriedLabels = queriedLabels
  },
  PUSH_TO_STATE(state, label) {
    state.queriedLabels[state.queriedLabels.length] = label
  }
}
